import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { getPost } from './blogs/posts'
import { BlogChrome } from './blogs/BlogChrome'
import './blogs/blogs.css'

// 單篇文章：/blogs/:slug
export default function BlogPost() {
  const { slug } = useParams<{ slug: string }>()
  const post = slug ? getPost(slug) : undefined
  if (!post) return <Navigate to="/blogs" replace />

  // 整段被「」框住的短句視為引用，套用左邊線樣式
  const isQuote = (p: string) => p.startsWith('「') && p.endsWith('」')

  return (
    <BlogChrome>
      <div className="card border-dark mb-3">
        <div className="blog-wrap">
          <Helmet>
            <title>{post.title} | Feis Studio</title>
          </Helmet>
          <h1 className="blog-post-title">{post.title}</h1>
          <div className="blog-post-meta">
            <span>{post.date}</span>
          </div>
          <div className="blog-post-body">
            {post.paragraphs.map((p, i) => (
              <p key={i} className={isQuote(p) ? 'blog-quote' : undefined}>
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </BlogChrome>
  )
}
